module.exports = __webpack_public_path__ + "static/media/wrench.a8fc2543.svg";